var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTanquesVinculado = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 36,
    viewBox: "0 0 56 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 25.6677C41.7343 27.1479 38.6901 26.9216 36.6667 25.0133V25.2H31.1667V28.8H36.6667V32.4H31.1667V36H44V25.6677ZM34.866 21.6C34.6766 20.3834 34.8654 19.1204 35.4298 18H31.1667V21.6H34.866ZM36.6667 16.3436V14.4H31.1667V14.22L20.9 7.56C21.45 5.94 22.3667 4.68 23.65 3.42C25.85 1.26 28.9667 0 32.0833 0C37.9406 0 42.6647 3.97334 43.8218 9.38117L36.6667 16.3436ZM32.0833 3.6C28.6 3.6 25.4833 5.76 24.3833 9H39.7833C38.6833 5.76 35.5667 3.6 32.0833 3.6ZM0 36V16.2L13.75 7.2L27.5 16.2V36H18.3333V23.4H9.16667V36H0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6672 6.2997C52.8899 4.56711 49.9979 4.56675 48.2203 6.29874L48.2206 6.2991L45.4083 9.04114L46.7065 10.3064L49.5193 7.56376L49.5191 7.56352C50.5812 6.52996 52.3077 6.53055 53.369 7.56519C54.4305 8.59983 54.4304 10.2837 53.369 11.3187L49.1483 15.433C48.8962 15.6802 48.5962 15.8762 48.2657 16.0097C47.9353 16.1431 47.581 16.2113 47.2233 16.2104C46.8656 16.2113 46.5113 16.1431 46.1809 16.0097C45.8504 15.8762 45.5504 15.6802 45.2982 15.433L44 16.6983C44.861 17.5377 46.0058 18 47.2235 18C48.4411 18 49.5859 17.5377 50.4465 16.6983L54.6673 12.5841C56.4442 10.8512 56.4442 8.03193 54.6672 6.2997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4815 22.4352C41.4198 23.4697 39.6926 23.4695 38.6311 22.4346C37.5696 21.3994 37.5696 19.715 38.631 18.68L42.8511 14.5654C43.9129 13.5303 45.6402 13.5303 46.7017 14.5654L48 13.2998C46.2224 11.5668 43.3304 11.5667 41.5531 13.2998L37.3327 17.4144C35.5557 19.1474 35.5557 21.9672 37.3328 23.7003C38.2217 24.5669 39.389 25.0001 40.5566 25C41.7237 25 42.891 24.567 43.7795 23.7009L43.7797 23.7008L46.5927 20.9575L45.2944 19.6919L42.4815 22.4352Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTanquesVinculado);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tanquesVinculado.9681c5ed38b8462cd02f6dea154bcec5.svg";